

export default {
  name: 'ContactPage',
  head() {
    return this.$utils.head(this.story)
  },
  async asyncData({ $utils }) {
    return {
      story: await $utils.content('contact'),
    }
  },
}
